import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from "vue-i18n";
import { computed } from "vue";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelect',
  setup(__props) {

const language = computed(() => store.getters.getAppLanguage);
const { locale } = useI18n();
const handleSetLanguage = () => {
  let localeValue = language.value == "en" ? "zh" : "en";
  store.dispatch("setAppLanguage", localeValue);
  locale.value = localeValue;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: handleSetLanguage,
    class: _normalizeClass([
      'header-' + _unref(language),
      {
        'moblie-language': _unref(store).state.isMobile,
      },
    ])
  }, null, 2))
}
}

})